import SpecService from "../../../common/services/catalog/SpecsService";
import KitService from "../../../common/services/kit/KitService";
import TranslationService from "../../../common/services/translation/TranslationService";
import axios from "../../../common/utils/axios";
import {
    FILTER_REQUEST,
    SET_BRANDS,
    SET_CATALOG,
    SET_SPEC,
    SET_FILTERS,
    SET_PRODUCTS,
    SET_CATEGORIES,
    SET_CATEGORIES_STRICT,
    SET_CONDITIONS,
    SET_MIN_PRICE,
    SET_MAX_PRICE,
    SET_MIN_YEAR,
    SET_MAX_YEAR,
    SET_PAGE,
    SET_CURRENT_PAGE,
    FILTER_RECOMMENDATION,
    GET_CATEGORY,
    SET_MIN_SPEC,
    SET_MAX_SPEC,
    SET_KEYWORDS,
    GET_FILTER_DISPLAY_SPECS,
    FILTER_REQUEST_TRADER,
    RESET_FILTER_REQUEST_TRADER,
    SET_KIT_SOURCE
} from "./actions";

export default {
    state: {
        view:"",
        kits: [],
        traderKits: [],
        canPaginate:true,
        recommendation: [],
        specTypesName: {
            TEXT: "text",
            MINMAX: "minmax",
            SELECT: "select",
            MULTISELECT: "multiselect",
            YESNO: "yesno",
        },
        rfpMode: false,
        pagination: {
            currentPage: 1,
            perPage: 15,
            records: 0,
            last_page:1,
        },
        subtitles: {
            Category: [],
            Brand: [],
            Models: [],
            Condition: [],
            Price: [],
            Year: [],
        },
        filterDisplaySpecs:[],
        filters: {
            brands: [],
            products: [],
            categories: [],
            categoriesStrict: [],
            keywords:[],
            conditions: [],
            specs: {},
            minPrice: -1,
            maxPrice: -1,
            minYear: -1,
            maxYear: -1,
            kitSource: [],
            page: 1,
            search: "",
            cat_id: "",
            kitsorder: "kits.created_at|DESC",
        },
        catalog: {
            brands: [],
            products: [],
            categories: [],
            categoryTree: {},
            keywords:[],
            conditions: [],
            specs: [],
            kitSources:[],
            minPrice: 0,
            maxPrice: 1000000,
            minYear: 1970,
            maxYear: 2023,
            perPageKits: 1,
            totalKits: 1,
        },
    },
    getters: {
        subtitles: (state) => state.subtitles,
        kits: (state) => state.kits,
        traderKits: (state) => state.traderKits,
        recommendation: (state) => state.recommendation,
        filters: (state) => state.filters,
        categoriesStrict: (state) => state.filters.categoriesStrict,
        filterCatalog: (state) => state.catalog,
        filterSpecs: (state) => state.specs,
        filterDisplaySpecs: (state)=>state.filterDisplaySpecs,
        filterPagination: (state) => state.pagination,
        specTypesName: (state) => state.specTypesName,
        rfpMode: (state) => state.rfpMode,
    },
    mutations: {
        resetFilters(state) {
            state.filters = {
                brands: [],
                products: [],
                categories: [],
                conditions: [],
                keywords:[],
                specs: {},
                minPrice: -1,
                maxPrice: -1,
                minYear: -1,
                maxYear: -1,
                page: 1,
                search: "",
                cat_id: "",
            };
            state.subtitles = {
                Category: [],
                Brand: [],
                Models: [],
                Condition: [],
                Price: [],
                Year: [],
            };
        },
    
        subtitles(state, data) {
            state.subtitles = data;
        },
        setRfpMode(state, value) {
            state.rfpMode = value;
        },
        setFilterPagination(state, data) {
            state.pagination.currentPage = data.current_page;
            state.pagination.perPage = data.per_page;
            state.pagination.records = data.total;
            state.pagination.last_page = data.last_page;
            state.catalog.per_page = data.per_page;
            state.catalog.current_page = data.current_page;
            state.catalog.total = data.total;
            state.catalog.last_page = data.last_page;
        },
        [SET_CURRENT_PAGE]: (state, data) => {
            state.pagination.currentPage = data;
        },
        [GET_FILTER_DISPLAY_SPECS]: (state, data) => {
            state.filterDisplaySpecs = data;
        },
        [FILTER_REQUEST]: (state, kits) => {
            state.kits = kits;
        },
        [FILTER_REQUEST_TRADER]: (state, traderKits) => {
            let newTraderKits = state.traderKits.slice()
            for(let i =0; i<traderKits.length; i++)
            {
                if (!newTraderKits.some(e => e.id === traderKits[i].id))
                {
                    newTraderKits.push(traderKits[i])
                }
            }
            state.traderKits = newTraderKits
        },
        [RESET_FILTER_REQUEST_TRADER]: (state) => {
            state.traderKits = [];
        },
        [FILTER_RECOMMENDATION]: (state, recommendation) => {
            state.recommendation = recommendation;
        },
        [SET_FILTERS]: (state, filters) => {
            state.filters = filters;
        },
        [SET_CATALOG]: (state, catalog) => {
            state.catalog.brands = catalog.brands;
            state.catalog.products = catalog.products;
            state.catalog.categories = catalog.categories;
            state.catalog.categoryTree = catalog.categoryTree;
            state.catalog.kitSources = catalog.kitSources;
            state.catalog.conditions = catalog.conditions;
            state.catalog.minPrice = catalog.minPrice;
            state.catalog.maxPrice = catalog.maxPrice;
            state.catalog.minYear = catalog.minYear;
            state.catalog.maxYear = catalog.maxYear;
            state.catalog.per_page = catalog.per_page;
            state.catalog.current_page = catalog.current_page;
            state.catalog.total = catalog.total;
            state.catalog.last_page = catalog.last_page;
            state.catalog.specs = catalog.specs;
        },
        setBrands:(state, data)=>{
            state.catalog.brands = data;
        },

        setCategories:(state, data)=>{
            state.catalog.categoryTree = data;
        },

        setKitSources:(state, data)=>{
            state.catalog.kitSources = data;
        },

        setKeywords:(state, data)=>{
            state.catalog.keywords = data;
        },

        setSpecs:(state, data)=>{
            
            state.catalog.specs = data;
        },

        setMaxPrice:(state, data)=>{
            state.catalog.maxPrice = data;
        },

        setMinPrice:(state, data)=>{
            state.catalog.minPrice = data;
        },

        

        [SET_PRODUCTS]: (state, productsIds) => {
            state.filters.products = productsIds;
        },
        [SET_BRANDS]: (state, brandsIds) => {
            state.filters.brands = brandsIds;
        },
        [SET_CATEGORIES]: (state, categoriesIds) => {
            state.filters.categories = categoriesIds;
        },

        [SET_CATEGORIES_STRICT]: (state, categoriesIds) => {
            state.filters.categoriesStrict = categoriesIds;
        },

        [SET_KEYWORDS]: (state, keywords) => {
            state.filters.keywords = keywords;
        },
        [SET_CONDITIONS]: (state, conditionsIds) => {
            state.filters.conditions = conditionsIds;
        },
        [SET_MIN_PRICE]: (state, value) => {
            state.filters.minPrice = value;
        },
        [SET_MAX_PRICE]: (state, value) => {
            state.filters.maxPrice = value;
        },
        [SET_KIT_SOURCE]: (state, kitSource) => {
            state.filters.kitSource = kitSource;
        },
        [SET_MIN_YEAR]: (state, value) => {
            state.filters.minYear = value;
        },
        [SET_MAX_YEAR]: (state, value) => {
            state.filters.maxYear = value;
        },
        [SET_MIN_SPEC]: (state, { value, spec }) => {
            if (state.filters.specs[spec.id]==undefined)
                state.filters.specs[spec.id] = {}
            
            state.filters.specs[spec.id]['min'] = value;

        },
        [SET_MAX_SPEC]: (state, { value, spec }) => {
            if (state.filters.specs[spec.id]==undefined)
                state.filters.specs[spec.id] = {}
            
            state.filters.specs[spec.id]['max'] = value;
        },
        [SET_PAGE]: (state, page) => {
            state.filters.page = page;
        },
        [SET_SPEC]: (state, { values, spec }) => {
         
            if (state.filters.specs[spec.id]==undefined)
                state.filters.specs[spec.id] = {}
            state.filters.specs[spec.id] = values;
            
        },
    },
    actions: {
        [GET_CATEGORY]: (context, id) => {
            return new Promise((resolve, reject) => {
                axios({
                        url: "categories/" + id,
                        method: "get",
                    })
                    .then((response) => {
                        return response.data.data.name;
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },
        [GET_FILTER_DISPLAY_SPECS]: async(context) => {
            var specService = new SpecService();

            let response = await specService.getFilterSpecs()

            context.commit(GET_FILTER_DISPLAY_SPECS, response.data.data)

            return response

        },
        [FILTER_REQUEST]: async(context) => {
            context.state.canPaginate = false
            context.commit(FILTER_REQUEST, []);
            var kitService = new KitService();
            var data = {
                brands: JSON.stringify(context.state.filters.brands),
                products: JSON.stringify(context.state.filters.products),
                categories: JSON.stringify(context.state.filters.categories),
                conditions: JSON.stringify(context.state.filters.conditions),
                kitSource: JSON.stringify(context.state.filters.kitSource),
                specs: JSON.stringify(context.state.filters.specs),
                minPrice: context.state.filters.minPrice,
                maxPrice: context.state.filters.maxPrice,
                minYear: context.state.filters.minYear,
                maxYear: context.state.filters.maxYear,
                ccode: context.getters.currency.code,
                page: context.state.pagination.currentPage,
                search: context.state.filters.search,
                cat_id: context.state.filters.cat_id,
                kitsorder: context.state.filters.kitsorder,
                keywords: JSON.stringify(context.state.filters.keywords),
            };

            kitService.filter(data, context.getters.isAuthenticated).then(
                async (response)=>{
                    context.commit(FILTER_REQUEST, response.data.data.kits.data);
                    context.commit(FILTER_REQUEST_TRADER, response.data.data.kits.data)
                    context.commit(FILTER_RECOMMENDATION, response.data.data.recommendation);
                    context.commit('addToTranslations',response.data.data.translations)
                    context.commit("setFilterPagination", response.data.data.kits);
                    context.state.canPaginate = true
                }
            );
           

            kitService.filterBrands(data).then(
                (response)=>{
                    context.commit('setBrands', response.data.data);
                }
            );

            kitService.filterCategories(data).then(
                (response)=>{
                    context.commit('setCategories', response.data.data);
                }
            );


            kitService.filterKitSources(data).then(
                (response)=>{
                    context.commit('setKitSources', response.data.data);
                }
            );

            kitService.filterKeywords(data).then(
                (response)=>{
                    context.commit('setKeywords', response.data.data);
                }
            );

            kitService.filterMaxPrice(data).then(
                (response)=>{
                    context.commit('setMaxPrice', response.data.data);
                }
            );

            kitService.filterMinPrice(data).then(
                (response)=>{
                    context.commit('setMinPrice', response.data.data);
                }
            );

            kitService.filterSpecs(data).then(
                (response)=>{
                    context.commit('setSpecs', response.data.data);
                }
            );
        },
    },
};